import { render, staticRenderFns } from "./Charity.vue?vue&type=template&id=52f4679c&"
import script from "./Charity.vue?vue&type=script&lang=js&"
export * from "./Charity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports